// extracted by mini-css-extract-plugin
export default {"tags":"tags_jXut","tag":"tag_QGVx"};